import api from './api';
import types from './mutation-types';

import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';

export default {
	// getVariableManagements_({ commit, state }, {varVal, strtDt} ) {

	// 	console.log('var', varVal, strtDt)
	// 	const { pagingInfo } = state;

	// 	return api
	// 		.getVariableManagements({varVal: varVal, strtDt: strtDt, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
	// 		.then(data => {
	// 			if (data.header.code === 0) {
	// 				return data;
	// 			} else {
	// 				throw new Error(data.header.message);
	// 				// throw new Error(data.header.messageCd);
	// 			}
	// 		})
	// 		.catch(error => {
	// 			throw error.header ? error.header : error;
	// 		});
	// },
	/**call API */
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);

			if (header.code === 0) {
				await commit(types.DEFAULT_ASSIGN, { key, value: body });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setCmpnMstSearchParam_({ commit }, { key, value }) {
		commit(types.CMPN_MST_SEARCH_PARAMS, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStateRoApcnPopup_({ commit }, { key, value }) {
		commit(types.RO_APCN_INFO, { key, value });
	},
	setStateApcnInit_({ commit }) {
		commit(types.STATE_APCN_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateApcnSave_({ commit }, { key, value }) {
		commit(types.RO_APCN_SAVE_INFO, { key, value });
	},
	setBtnApprAuth_({ commit, state }) {
		//승인,기각,반려,권한
		let prcsStep = state.roApcnPopUp.prcsStepr || '';

		let result = false;

		//console.log('승인기각 화면권한은 있음>>>>>', prcsStep);
		if (prcsStep == '20') {
			//console.log('신청일경우에는 승인,기각,반려 할수있다.');
			result = true;
		} else {
			//신청상태가 아니면 승인 기각 반려를 할수가 없다.
			//console.log('신청상태가 아니면 승인 기각 반려를 할수가 없다.');
			result = false;
		}

		commit(types.RO_APCN_INFO, {
			key: 'btnApprAuth',
			value: result
		});
	},
	setBtnDelAuth_({ commit, state }, paramAuth) {
		//
		//신청버튼 권한
		let prcsStep = state.roApcnPopUp.prcsStepr || '';
		let aplcDd = state.roApcnPopUp.aplcDdr || '';
		//let prcsRslt = state.roApcnPopUp.prcsRslt || '';
		let result = false;

		if (paramAuth) {
			//console.log('삭제화면권한은 있음');
			if (prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우');
				result = true;
			} else {
				//console.log('임시저장일경우에만 삭제가 가능하다.');
				result = false;
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.RO_APCN_INFO, {
			key: 'btnDelAuth',
			value: result
		});
	},
	setBtnApAuth_({ commit, state }, paramAuth) {
		//setDelAuth_
		//신청버튼 권한

		//console.log('입력전', state.roApcnPopUp.prcsStepr);

		let prcsStep = state.roApcnPopUp.prcsStepr || '';
		let aplcDd = state.roApcnPopUp.aplcDdr || '';
		//let prcsRslt = state.roApcnPopUp.prcsRslt || '';
		let result = false;

		//console.log('가나다라마2>>>[' + prcsStep + ']');

		if (paramAuth) {
			//console.log('화면권한은 있음', prcsStep);
			if (prcsStep == '' || prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우 신청버튼을 노출시킨다.');
				result = true;
			} else {
				//처리단계가 신청이며 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				if (prcsStep != '20' && aplcDd != '') {
					//console.log('처리단계가 신청단계며  신청일자가 있을경우 신청버튼을 버튼을 감춘다.');
					result = false;
				}
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.RO_APCN_INFO, {
			key: 'btnApAuth',
			value: result
		});
	},
	setBtnTsAuth_({ commit, state }, paramAuth) {
		//임시저장버튼 권한설정
		let prcsStep = state.roApcnPopUp.prcsStepr || '';
		let aplcDd = state.roApcnPopUp.aplcDdr || '';
		//let prcsRslt = state.roApcnPopUp.prcsRslt || '';
		let result = false;

		//console.log('가나다라마1>>>', prcsStep);

		if (paramAuth) {
			//console.log('화면권한은 있음');
			if (prcsStep == '' || prcsStep == '10') {
				//console.log('처음 PWA생성하거나 임시저장일경우');
				result = true;
			} else {
				//처리단계가 임시저장이 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.
				if (prcsStep != '10') {
					//console.log('처리단계가 신청단계가 아니며  처리결과가 공백이 아닐경우 없을경우 임시저장 버튼을 감춘다.');
					result = false;
				}
			}
		} else {
			//console.log('화면권한은 없음');
			result = false;
		}

		commit(types.RO_APCN_INFO, {
			key: 'btnTsAuth',
			value: result
		});
	},
	getRoApcnList_({ commit, state }) {
		//신청현황리스트조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch
		const { searchParams, pagingInfo } = state;

		return api
			.getRoApcnList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					//console.log('데이터값은뭐냐>>>>>', data.body);

					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	async getRoApcnPopList_({ commit, state }, roNoParam) {
		// RO신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getRoApcnPopList(roNoParam.roNo)
			.then(data => {
				//console.log('return data>??>>>>>>', data);

				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnPopUp',
						value: data?.body.resultVo || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnSwapPartsList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnOtherFeeList',
						value: data?.body.otherFeeList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnCommentList',
						value: data?.body.commentList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'fileList',
						value: data?.body.fileList || []
					});
					/*임시저장후 다시 PWA번호를 선택시 이전에 저장된 RO번호가 날라가기때문에 저장함.*/
					commit(types.DEFAULT_ASSIGN, {
						key: 'beRoNo',
						value: data?.body.resultVo.roNo || ''
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'bePrcsStepr',
						value: data?.body.resultVo.prcsStepr || ''
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'bePrcsStempNmr',
						value: data?.body.resultVo.prcsStepNmr || ''
					});

					/*리드온리 권한 */
					//console.log('리드온리권한', data.body.resultVo.pwaNo);

					let rsltPwaNo = convertNvl(data.body.resultVo.pwaNo, '');

					//console.log('값은뭐냐', rsltPwaNo);

					commit(types.RO_APCN_INFO, {
						key: 'readOnlyAuth',
						value: data.body.resultVo.prcsStepr == '20' || data.body.resultVo.prcsStepr == '30' || rsltPwaNo != '' ? true : false
					});

					commit(types.RO_APCN_INFO, {
						key: 'readOnlyAuth1',
						value: data.body.resultVo.prcsStepr == '20' || data.body.resultVo.prcsStepr == '30' ? true : false
					});

					//임시저정후 버튼권한 노출 처리 (임시저장, 신청 , 삭제)

					//console.log('여기냐1>>>>>', roNoParam.paramState);
					if (roNoParam.paramState === '10') {
						//console.log('여기냐2>>>>>', roNoParam.paramState);
						/*임시저장버튼 권한*/
						commit(types.RO_APCN_INFO, {
							key: 'btnTsAuth',
							value: data.body.resultVo.prcsStepr == '10' ? true : false
						});
						/*신청버튼 권한 */
						commit(types.RO_APCN_INFO, {
							key: 'btnApAuth',
							value: data.body.resultVo.prcsStepr == '10' ? true : false
						});
						/*삭제버튼 권한 */
						commit(types.RO_APCN_INFO, {
							key: 'btnDelAuth',
							value: data.body.resultVo.prcsStepr == '10' ? true : false
						});
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	apprDupCnt_({ commit, state }, payload) {
		//param,
		return api
			.apprDupCnt(state)
			.then(data => {
				//console.log('data 값은>>', data);
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	async getPwaApcnPopList_({ commit, state }, pwaNoParam) {
		// PWA신청팝업조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return await api
			.getPwaApcnPopList(pwaNoParam)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnPopUp',
						value: data?.body.resultVo || {}
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'selectedPmcId',
						value: data?.body.resultVo.pmcId || {}
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnSwapPartsList',
						value: data?.body.resultList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnOtherFeeList',
						value: data?.body.otherFeeList || []
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'fileList',
						value: data?.body.fileList || []
					});

					//State복사 예시
					//commit(types.STATE_COPY_RO_INFO);

					/*리드온리 권한 */
					//console.log('리드온리권한', data.body.resultVo);

					let prcsStepr = data.body.resultVo.prcsStepr || '';

					//console.log('리드온리권한 값은????????>>>', prcsStepr);

					commit(types.RO_APCN_INFO, {
						key: 'readOnlyAuth',
						value: prcsStepr == '20' || prcsStepr == '30' || data.body.resultVo.pwaNo != '' ? true : false
					});

					commit(types.RO_APCN_INFO, {
						key: 'readOnlyAuth1',
						value: prcsStepr == '20' || prcsStepr == '30' ? true : false
					});

					//컴포넌트 삭제 플레그 초기화

					commit(types.DEFAULT_ASSIGN, {
						key: 'isDelCompInitFlag',
						value: false
					});

					//console.log('가나다라마>>>', data.body.resultVo.prcsStepr);
					//pwa에서는 이렇게 버튼을 열어야됨.
					/*
					if (!prcsStepr) {
						commit(types.RO_APCN_INFO, {
							key: 'btnTsAuth',
							value: true
						});

						commit(types.RO_APCN_INFO, {
							key: 'btnApAuth',
							value: true
						});

						commit(types.RO_APCN_INFO, {
							key: 'btnDelAuth',
							value: data.body.resultVo.prcsStep == '10' ? true : false
						});
					}
					*/

					//console.log('state roNo', state.beRoNo);
					//console.log('state prcStep', state.bePrcsStepr);
					//console.log('state prcStemPn', state.bePrcsStempNmr);

					let beRoNo = state.beRoNo || '';
					//임시저장이 된 상태이기 때문에 기존에 등록된RONO번호를 셋팅한다.
					if (beRoNo !== '') {
						commit(types.RO_APCN_INFO, {
							key: 'roNo',
							value: state.beRoNo
						});

						commit(types.RO_APCN_INFO, {
							key: 'prcsStepr',
							value: state.bePrcsStepr
						});

						commit(types.RO_APCN_INFO, {
							key: 'prcsStepNmr',
							value: state.bePrcsStempNmr
						});
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}, //실제 파일명을 클릭했을때 다운로드 하기 위한 함수
	async fileDownload_(store, params = { fileId, fileSeq }) {
		//console.log('fileId/>>>>>>>', params);
		try {
			const response = await api.fileDownload({ params });
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			return error.header || error;
		}
	},
	saveRoApcnPopup_({ commit }, { formData }) {
		/*fromData 찍어보기*/
		return api
			.saveRoApcnPopup({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	delApcnRoSwapInfoList_({ commit }, param) {
		return api
			.delApcnRoSwapInfoList(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'roApcnSwapPartsList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	saveStateAppr_({ commit, state }, payload) {
		//param,
		return api
			.saveStateAppr(state)
			.then(data => {
				//console.log('data 값은>>', data);
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	deleteRoApcnPopup_({ commit }, param) {
		//console.log('파람', param);
		return api
			.deleteRoApcnPopup(param)
			.then(data => {
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	checkPwa_({ commit }, param) {
		//신청할때 체크함
		//console.log('파람', param);
		return api
			.checkPwa(param)
			.then(data => {
				if (data.header.code === 0) {
					//pwaRegCnt: '', //임시저장 또는 신청시 pmcId, 원인부품번호, 주행거리를 기준으로 PWA 번호 등록건수

					if (data.body.result !== null) {
						commit(types.RO_APCN_SAVE_INFO, {
							key: 'pwaRegCnt',
							value: data?.body.result.pwaRegCnt || []
						});

						//preRegPwaNo: '' //임시저장 또는 신청시 pmcId, 원인부품번호, 주행거리를 기준으로 PWA 번호
						//commit(types.RO_APCN_SAVE_INFO, {
						//		key: 'preRegPwaNo',
						//			value: data?.body.result.preRegPwaNo || []
						//	});
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				//console.log('data>>?>>', data);

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	chkPmcIdCampNo_({ commit }, param) {
		//신청할때 체크함
		//console.log('파람', param);
		return api
			.chkPmcIdCampNo(param)
			.then(data => {
				if (data.header.code === 0) {
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'chkPmcIdCampNoList',
						value: data?.body.result.cmpnNmList || []
					});
					*/
					//data = data.body.result.cmpnNmList
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},

	/*******************************************얼그레이아이스티 ******************************/
	////////////////////////팝업 캠페인 목록 관련 로직////////////////////
	setCmpnMstInit_({ commit }) {
		commit(types.STATE_CMPN_MST_INIT);
	},
	setCmpnOpCdInit_({ commit }) {
		commit(types.STATE_CMPN_OP_CD_INIT);
	},
	//캠페인 팝업 캠페인 그리드 조회
	getCmpnMstList_({ commit, state }, param) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { cmpnMstSearchParams } = state;

		if (param == null) {
			return api
				.getCmpnMstList(cmpnMstSearchParams)
				.then(data => {
					if (data.header.code === 0) {
						commit(types.DEFAULT_ASSIGN, {
							key: 'cmpnMstList',
							value: data?.body.resultList || []
						});
					}
					if (data.header.code === 1) {
					}
					if (data.header.code === 2) {
					}
					if (data.header.code === 3) {
					}
					if (data.header.code === 4) {
					}
					if (data.header.code === 5) {
					}

					return data.header;
				})
				.catch(error => {
					throw error.header ? error.header : error;
				});
		} else {
			const cmpnMstSearchParams = {
				cmpnNo: param,
				pmcId: state.cmpnMstSearchParams.pmcId
			};
			return api
				.getCmpnMstList(cmpnMstSearchParams)
				.then(data => {
					//console.log('data 가잦거저딪겆디', data);
					if (data.header.code === 0) {
						commit(types.DEFAULT_ASSIGN, {
							key: 'selectedCmpnMstList',
							value: data?.body.resultList || []
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCausPartNo',
							value: data?.body.resultList[0].causPartNo || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCausPartNm',
							value: data?.body.resultList[0].causPartNm || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCausCd',
							value: data?.body.resultList[0].causCd || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCausNm',
							value: data?.body.resultList[0].causNm || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentPhmnCd',
							value: data?.body.resultList[0].phmnCd || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentPhmnNm',
							value: data?.body.resultList[0].phmnNm || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCpnyNm',
							value: data?.body.resultList[0].cpnyNm || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentdlvgNm',
							value: data?.body.resultList[0].dlvgNm || ''
						});

						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCmpnStdt',
							value: moment(data?.body.resultList[0].strtDd).format('YYYY-MM-DD') || ''
						});
						commit(types.DEFAULT_ASSIGN, {
							key: 'currentCmpnEndDt',
							value: moment(data?.body.resultList[0].endDd).format('YYYY-MM-DD') || ''
						});
					}
					if (data.header.code === 1) {
					}
					if (data.header.code === 2) {
					}
					if (data.header.code === 3) {
					}
					if (data.header.code === 4) {
					}
					if (data.header.code === 5) {
					}

					return data.header;
				})
				.catch(error => {
					throw error.header ? error.header : error;
				});
		}
	},
	//캠페인 팝업 OP코드 그리드 조회
	getCmpnMstPopList_({ commit, state }, param) {
		return api
			.getCmpnMstPopList(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'opCodeList',
						value: data?.body.cmpnOpList || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//캠페인 팝업 교환부품정보 그리드 조회
	getSearchCmpnPartList_({ commit, state }, param) {
		return api
			.getSearchCmpnPartList(param)
			.then(data => {
				//console.log('캠페인조회된>>>', data);
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnPartList',
						value: data?.body.cmpnPartList || {}
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getPopupCarSales_({ commit, state }, param) {
		const { pagingInfo } = state;
		return api
			.getPopupCarSales({ param, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
					throw new Error(data.header.message);
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//팝업 pwa 목록 조회
	getRoUsedYear_({ commit, state }, param) {
		//신청현황리스트조회
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		return api
			.getRoUsedYear(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.RO_APCN_INFO, {
						key: 'selUsedYear',
						value: data.body.rsVo.usePrd
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	apprSaveRoList_({ commit }, { formData }) {
		/*fromData 찍어보기*/
		return api
			.apprSaveRoList({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	apprSaveRoOutBound_({ commit }, { formData }) {
		/*fromData 찍어보기*/ 
		return api
			.apprSaveRoOutBound({ formData })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
					// throw new Error(data.header.messageCd);
				}
			})
			.catch(error => {
				throw error;
			});
	},
	addCostUpload_({ commit }, { formData }) {
		return api
			.addCostUpload({ formData })
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	roCostMatch_(){
		return api
			.roCostMatch()
			.then(data => {
				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
	/*******************************************얼그레이아이스티 ******************************/
};
